module.exports = __webpack_public_path__ + "static/media/av1.91d56d46.png";